import React from "react";
const spinner = () => {
  return (
    <div className="spinner">
      <div className="positionSpinner">
        <div className="loader">Loading...</div>
      </div>
    </div>
  );
};
export default spinner;
